import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { BlogItemComponent } from 'src/app/view/blogs/blog-item/blog-item.component';
import { BlogsComponent } from 'src/app/view/blogs/blogs.component';
import { RouterModule } from '@angular/router';



@NgModule({
  declarations: [
    BlogsComponent,
    BlogItemComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild([
      {path:'',component:BlogsComponent,children:[
        {path:':id',component:BlogItemComponent}
    ]},
    ])
  ]
})
export class BlogsModule { }
